import type { HeyeaSession, OutlookContext } from "../core/types";
import type { TimeFinderRequestStatusDto } from "@hai/common";
import type { TimeFinderResult } from "@hai/time-finder";

const mockResult: TimeFinderResult = {
    "rec": {
      "endIso": "2026-01-05T17:00:00Z",
      "startIso": "2026-01-05T16:30:00Z"
    },
    "alts": [],
    "attendeeLayers": [
      {
        "id": "attendee-mho@fendv.com",
        "meta": {
          "kind": "attendee",
          "calendarIds": [
            "45e27c35-57d2-4b46-a065-9301d667cbca",
            "481c2a09-d4f1-4e0e-929d-69bea00dfa57",
            "db7ced0f-11c0-4840-878e-fc11172e5aa5"
          ],
          "resolvedVia": "provider_connection",
          "attendeeName": "Min-Shun Ho",
          "attendeeEmail": "mho@fendv.com"
        },
        "name": "Min-Shun Ho",
        "segments": [
          {
            "end": 1963796,
            "start": 1963786,
            "value": 2.303981267728023
          },
          {
            "end": 1963842,
            "start": 1963839,
            "value": 1.3583030583147706
          },
          {
            "end": 1963848,
            "start": 1963844,
            "value": 2.792047720888264
          },
          {
            "end": 1964034,
            "start": 1964032,
            "value": 2.9994126826014678
          },
          {
            "end": 1964040,
            "start": 1964036,
            "value": 1.7572311971261712
          },
          {
            "end": 1964044,
            "start": 1964040,
            "value": 1.8252578090325728
          },
          {
            "end": 1964136,
            "start": 1964132,
            "value": 1.7072312706215413
          },
          {
            "end": 1964143,
            "start": 1964137,
            "value": 1.0860835130983932
          },
          {
            "end": 1964162,
            "start": 1964158,
            "value": 1.4080159875576528
          },
          {
            "end": 1964180,
            "start": 1964170,
            "value": 1.332267145467003
          },
          {
            "end": 1964232,
            "start": 1964228,
            "value": 1.657231373052097
          },
          {
            "end": 1964248,
            "start": 1964244,
            "value": 2.557778810275569
          },
          {
            "end": 1964256,
            "start": 1964254,
            "value": 1.5531601468871596
          }
        ]
      },
      {
        "id": "attendee-buzzrobotnik@gmail.com",
        "meta": {
          "kind": "attendee",
          "calendarIds": [
            "44c5eb98-407d-4fc7-a355-c6b51c1441ed"
          ],
          "resolvedVia": "provider_connection",
          "attendeeName": "buzzrobotnik@gmail.com",
          "attendeeEmail": "buzzrobotnik@gmail.com"
        },
        "name": "buzzrobotnik@gmail.com",
        "segments": [
          {
            "end": 1963769,
            "start": 1963764,
            "value": 3.5567760921909666
          },
          {
            "end": 1964032,
            "start": 1964028,
            "value": 1.5140941272185708
          },
          {
            "end": 1964041,
            "start": 1964039,
            "value": 1.7753969811578854
          },
          {
            "end": 1964057,
            "start": 1964052,
            "value": 2.4337247303622442
          },
          {
            "end": 1964128,
            "start": 1964124,
            "value": 1.4642198676614435
          },
          {
            "end": 1964142,
            "start": 1964140,
            "value": 1.3817537204411101
          },
          {
            "end": 1964153,
            "start": 1964148,
            "value": 2.3835183589102082
          },
          {
            "end": 1964224,
            "start": 1964220,
            "value": 1.4140943511769044
          },
          {
            "end": 1964249,
            "start": 1964244,
            "value": 2.333432430167971
          }
        ]
      },
      {
        "id": "attendee-otherrobot@gmail.com",
        "meta": {
          "kind": "attendee",
          "calendarIds": [
            "21312234-407d-4fc7-a355-c6b51c1441ed"
          ],
          "resolvedVia": "provider_connection",
          "attendeeName": "otherrobot@gmail.com",
          "attendeeEmail": "otherrobot@gmail.com"
        },
        "name": "otherrobot@gmail.com",
        "segments": [
          {
            "end": 1963769,
            "start": 1963764,
            "value": 1.5567760921909666
          },
          {
            "end": 1964032,
            "start": 1964028,
            "value": 1.5140941272185708
          },
          {
            "end": 1964041,
            "start": 1964039,
            "value": 3.7753969811578854
          },
          {
            "end": 1964057,
            "start": 1964052,
            "value": 2.4337247303622442
          },
          {
            "end": 1964128,
            "start": 1964124,
            "value": 1.4642198676614435
          },
          {
            "end": 1964142,
            "start": 1964140,
            "value": 1.3817537204411101
          },
          {
            "end": 1964153,
            "start": 1964148,
            "value": 2.3835183589102082
          },
          {
            "end": 1964224,
            "start": 1964220,
            "value": 1.4140943511769044
          },
          {
            "end": 1964249,
            "start": 1964244,
            "value": 3.333432430167971
          }
        ]
      }
    ]
  };

const mockDiagnostics = {
  stage: "production",
  timers: {
    fetchMs: 248,
    totalMs: 1037,
    calendarMs: 779,
  },
  windows: 1,
  strategy: "batched",
  warnings: [] as string[],
  correlationId: "5a395536-d772-4241-99be-283126aeb79d",
  eventsFetched: 9,
  calendarsTotal: 4,
  organizerEmail: "mho@fendv.com",
  calendarsSelected: 4,
  destinationCalendarId: "db7ced0f-11c0-4840-878e-fc11172e5aa5",
  destinationCalendarName: "mho@fendv.com",
  attendeeComplexityReturned: 1,
};

export const MOCK_STATUS_ROW: TimeFinderRequestStatusDto = {
  id: "mock-timefinder-id",
  status: "DONE",
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  data: {
    result: mockResult,
    diagnostics: mockDiagnostics,
  },
};

export const MOCK_SESSION: HeyeaSession = {
  access_token: "mock-access-token",
  refresh_token: "mock-refresh-token",
  expires_at: Math.floor(Date.now() / 1000) + 3600,
  expires_in: 3600,
  token_type: "bearer",
  user: {
    id: "mock-user-id",
    email: "mho@fendv.com",
    aud: "authenticated",
    role: "authenticated",
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    app_metadata: {},
    user_metadata: {},
  },
};

export const MOCK_CONTEXT: OutlookContext = {
  itemType: "message",
  subject: "Test Meeting Subject",
  bodyPreview: "This is a mock meeting body for local testing.",
  attendees: [
    {
      email: "mho@fendv.com",
      displayName: "Min-Shun Ho",
      role: "self",
    },
    {
      email: "teammate@example.com",
      displayName: "Teammate",
      role: "required",
    },
  ],
  timezone: "America/Chicago", // CST/CDT timezone
};

export const MOCK_CALENDAR_LINK = "https://calendar.google.com/calendar/r";
